import React from "react";
import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  AUTHORIZED_URL_PREFIX,
  UNITOVERVIEW_URL_WITHOUT_PARAM,
  VIEW_UNIT_URL,
  UNITIFRAME_URL_WITHOUT_PARAM,
  LIBRARY_VIDEO,
  LIBRARY_AUDIO,
  LIBRARY_STUDENTBOOK,
  LIBRARY_TEACHERBOOK,
  NOTIFICATION_SEVERITY_INFO,
  AxiosConfig,
} from '../../Utils/Constants';
import UnitModal from './../common/UnitModal';
import VideoModal from './../common/VideoModal';
import DoneIcon from '@mui/icons-material/Done';
import {CardActions, CardContent, CardHeader, IconButton, Typography} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";

export default function MultiActionStoryCard(props) {

  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = async () => {
    setShow(true)
    try {
      const { data } = await axios.post(
        `${AUTHORIZED_URL_PREFIX}${VIEW_UNIT_URL}`,
        { unitId: props.story._id, progress: null, score: null },
        AxiosConfig(),
      )
      if (data.success === true) {
        console.log('Successfully added unit usage')
        props.story.usage++
      }
    } catch (error) {
      console.log('Oops, something went wrong with viewing the unit')
    }

    console.log("props.story",props.story)
  }

    const t = props.t;

    const story = props.story;
  console.log(story.coverColor)
  const backgroundColor = story.coverColor ? story.coverColor : "rgb(0, 61, 125)";
    const duration = props.story.duration;


    let cover = story.type === 'Story-Video' ? `${props.story.s3Url}#t=1` : story.type === 'Story-Article' ? story.coverS3Link  : story.s3Url;

    return <ContentCard story={story} show={show} handleClose={handleClose} handleShow={handleShow} cover={cover} duration={duration} title={props.story.title} backgroundColor={backgroundColor} />
}


const ContentCard = (props) => {
  const duration = props.duration;
  const completed = props.completed;
  const handleShow = props.handleShow;
  const story = props.story;
  const bgColor = props.backgroundColor;

  return (<>
    {/*<div className='lykiocss-story-item hand' onClick={()=>{handleShow()}} style={{ width: '22rem', height: '24rem', background: "linear-gradient(to right, #00397a, #00a4f9)", position: 'relative' }}>*/}
    {/*  <img*/}
    {/*    src={props.cover}*/}
    {/*    alt="Cover image"*/}
    {/*    style={{*/}
    {/*      width: '100%',*/}
    {/*      height: '80%',*/}
    {/*      position: 'absolute',*/}
    {/*      top: '50%',*/}
    {/*      left: '50%',*/}
    {/*      transform: 'translate(-50%, -50%)'*/}
    {/*    }}*/}
    {/*  />*/}
    {/*  <div className="lykiocss-center" style={{ paddingTop: '0.5%', color:'white', fontSize:'20px', fontWeight:'500' }}>*/}
    {/*    <span>{props.title && props.title.length>25 ? `${props.title.substring(0, 25)}${props.title.length>25 && '...'}` : props.title}</span>*/}
    {/*  </div>*/}
    {/*  <div style={{ position: 'absolute', bottom: '0', left:'0.5em', width: '100%', color:'white', fontSize:'18px', fontWeight:'500' }}>*/}
    {/*    <span style={{position:'absolute', right:'325px', bottom:'5px'}}>{props.story.completed ? <DoneIcon/> : <></>}</span>  <span style={{position:'absolute', right:'43px', bottom:'5px'}}>{duration && `${duration} min`}</span>*/}
    {/*  </div>*/}
    {/*</div>*/}
        <div className="card text-white text hand " onClick={()=>{handleShow()}} style={{ background: bgColor }}>
          <div className="card-header text-center py-2" >{props.title}</div>
          <img className="card-img" src={props.cover} alt='Cover image'/>
          <div className="card-footer d-flex justify-content-between py-0" style={{background: bgColor}}>
            <div>{props.story.completed ? <DoneIcon/> : <></>}</div>
            <div>
              <div>{duration && `${duration} min`}</div>
            </div>
          </div>
        </div>
    <UnitModal unit={props.story} show={props.show} handleClose={props.handleClose} />
    </>
  );
}